$(document).ready(function() {
	var parent_node = document.querySelector('.GPC0105');
	if(!parent_node) return false;

	var day_timeline = document.querySelectorAll(".day-timeline");

	for(var idx = 0; idx < day_timeline.length; idx++){
		var days = [];
		// day timeline length check
		// just one
		if( 2 > day_timeline.length ){
			$(day_timeline).eq(idx).find(".btn-toggle").attr({
				"aria-disabled" : true,
				"disabled" : true
			});
			return false;
		// more than one
		}else{
			days[idx] = new Timeline(day_timeline[idx]);
			days[idx].init();
		}
	}

	function Timeline(element_node){
		var $this = $(element_node);
		var $content = $this.find(".day-timeline-list-wrap");
		var p = Timeline.prototype;
		p.init = function(){
			p.eventLitsener();
		}
		p.eventLitsener = function(){
			$this.find(".btn-toggle").on("click", function(){
				p.accessibility($(this));
				p.toggleEvent($content);
			});
		}
		p.accessibility = function($target){
			if($target.attr("aria-expanded") === "true"){
				$target.attr("aria-expanded", "false");
			}else{
				$target.attr("aria-expanded", "true");
			}
		}
		p.toggleEvent = function(tg){
			tg.collapse("toggle");
		}
	}
});
